import { camelCase } from 'lodash';
import { Violation, Violations } from '.';

export const violationFilterValue = (violation: Violation) => camelCase(violation);

// Mapping between customer-facing and api
const violationApiKeys: Record<string, keyof Violations> = {
  [violationFilterValue(Violation.ENTITY)]: 'regex',
};

export const toViolationApiKey = (filterValue: string): string =>
  violationApiKeys[filterValue] ?? filterValue;

export const getViolations = (violations: Violations) => {
  const {
    sensitiveData,
    pii,
    intent,
    access,
    confidentialData,
    promptInjection,
    toxicity,
    code,
    bias,
    risk,
    input,
    output,
    tool,
    training,
    license,
    fileUpload,
    regex,
  } = violations;
  const activeViolations: Violation[] = [];
  if (sensitiveData || pii) {
    activeViolations.push(Violation.PII);
  }

  if (intent) {
    activeViolations.push(Violation.INTENT);
  }

  if (access) {
    activeViolations.push(Violation.ACCESS);
  }

  if (confidentialData) {
    activeViolations.push(Violation.CONFIDENTIAL_DATA);
  }

  if (promptInjection) {
    activeViolations.push(Violation.PROMPT_INJECTION);
  }

  if (toxicity) {
    activeViolations.push(Violation.TOXICITY);
  }

  if (code) {
    activeViolations.push(Violation.CODE);
  }

  if (bias) {
    activeViolations.push(Violation.BIAS);
  }

  if (risk) {
    activeViolations.push(Violation.RISK);
  }

  if (input) {
    activeViolations.push(Violation.INPUT);
  }

  if (output) {
    activeViolations.push(Violation.OUTPUT);
  }

  if (tool) {
    activeViolations.push(Violation.TOOL);
  }

  if (training) {
    activeViolations.push(Violation.TRAINING);
  }

  if (license) {
    activeViolations.push(Violation.LICENSE);
  }

  if (fileUpload) {
    activeViolations.push(Violation.FILE_UPLOAD);
  }

  if (regex) {
    activeViolations.push(Violation.ENTITY);
  }
  return activeViolations;
};

export enum SurePathServiceName {
  GATEWAY = 'Gateway (Claude Code)',
  PORTAL = 'Portal',
  SDK = 'SDK',
  SUREPATH_AI = 'SurePath AI',
}

export enum ReferrerRelation {
  ANY = '',
  ALIGNED = 'aligned',
  MISMATCHED = 'mismatched',
}
